<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <section id="cta" class="rod-section relative overflow-hidden">
    <div class="rod-aurora" />
    <div class="rod-container relative">
      <div class="rod-card rod-card--glow text-center py-16 px-6 lg:px-12 max-w-4xl mx-auto" data-reveal style="background: linear-gradient(135deg, rgba(245,158,11,0.12) 0%, rgba(16,185,129,0.08) 100%); border-color: rgba(245,158,11,0.3);">
        <h2 class="rod-h2 mb-5 rod-gradient-text">{{ t('cta.title') }}</h2>
        <p class="text-lg text-[var(--color-text-muted)] max-w-xl mx-auto mb-10">{{ t('cta.lead') }}</p>

        <div class="flex flex-wrap justify-center gap-4">
          <a :href="`mailto:hello@romba.am?subject=${encodeURIComponent(t('cta.mailSubject'))}`" class="rod-btn-primary">
            {{ t('cta.primary') }}
            <span aria-hidden="true">→</span>
          </a>
          <a href="#products" class="rod-btn-secondary">{{ t('cta.secondary') }}</a>
        </div>
      </div>
    </div>
  </section>
</template>
